import { Breadcrumb } from 'antd';
import React from 'react';

const ReportAddress: React.FC = () => (
  <Breadcrumb style={{marginTop:'18px',fontSize:'16px',marginBottom:'11px'}} separator=">">
    <Breadcrumb.Item> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '主頁' : '主页'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '最新活動' : '最新活动'}</Breadcrumb.Item>

   
  </Breadcrumb>
);

export default ReportAddress;